import { formatDateShort } from "../format-user";
import type { TosAcceptanceSummary } from "../types";

/**
 * The profile summary of the in-app ToS acceptances: the most recent one as
 * "date · vVersion", or null when the user never accepted. The admin detail
 * returns the full history; the drill-down lives in the ToS section below.
 */
export function latestTosSummary(acceptances: readonly TosAcceptanceSummary[]): string | null {
  const latest = [...acceptances].sort((a, b) => b.acceptedAt.localeCompare(a.acceptedAt))[0];
  if (!latest) return null;
  return `${formatDateShort(latest.acceptedAt)} · v${latest.tosVersion}`;
}
